<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="name" slot-scope="name">
          <div>
            <div class="font-weight-bold">{{name}}</div>
            <!-- <div class="text-gray-4">{{user.position}}</div> -->
          </div>
        </template>
        <template slot="grade_group_description" slot-scope="grade_group_description">
          <div>{{grade_group_description}}</div>
        </template>
        <template slot="grades_count" slot-scope="grades_count">
          <div>{{grades_count}}</div>
        </template>
        <template slot="is_default" slot-scope="is_default">
          <a-tag v-if="is_default" color="green">{{is_default ? 'Default' : ''}}</a-tag>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <a href="javascript:;" v-if="record.is_default !== 1" class="btn btn-sm btn-success btn-with-addon mr-2"
              @click="handleSetDefault(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-disc" />
              </span>
              Make Default
            </a>
            <!-- Edit -->
            <a href="javascript:;" class="btn btn-sm btn-light btn-with-addon mr-2"
              @click="showEditModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              <!-- <edit-exam-grade ref="editExamType" @edited="handleEdited"/> -->
              Edit
            </a>
            <!-- Delete -->
            <a href="javascript:;" class="btn btn-sm btn-danger btn-with-addon"
              @click="onDelete(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-trash" />
              </span>
              Delete
            </a>
          </div>
        </template>
      </a-table>
    </div>
    <edit-exam-grade ref="editExamType" @edited="handleEdited"/>
  </div>
</template>
<script>
import EditExamGrade from '@/components/exam/grades/Forms/Edit/index'

const columns = [
  {
    title: 'Exam Types',
    dataIndex: 'name',
    className: 'text-left text-gray-6',
    scopedSlots: { customRender: 'name' },
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: 'Descriptions',
    dataIndex: 'grade_group_description',
    scopedSlots: { customRender: 'grade_group_description' },
    sorter: (a, b) => a.grade_group_description.localeCompare(b.grade_group_description),
  },
  {
    title: 'No. of grades',
    dataIndex: 'grades_count',
    scopedSlots: { customRender: 'grades_count' },
    sorter: (a, b) => a.grades_count - b.grades_count,
  },
  {
    title: 'Default grade',
    dataIndex: 'is_default',
    scopedSlots: { customRender: 'is_default' },
    sorter: (a, b) => a.is_default - b.is_default,
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]

export default {

  name: 'ExamGradeTable',
  components: {
    EditExamGrade,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function() {
    return {
      columns,
      selectedRowKeys: [],
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showEditModal: function(record) {
      // this.$refs.editExamType.showModal(record.id, record)
      this.$eventBus.$emit('openExamGradesEditModal', record.id, record)
    },
    handleEdited: function () {
      this.$emit('updateTable')
    },
    handleSetDefault(record) {
      this.$confirm({
        title: 'Are you sure?',
        content: 'Set ' + record.name + ' as default grade?',
        okText: 'Yes',
        okType: 'primary',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .get('/api/gradegroup/setdefault/' + record.id)
            .then(({ data }) => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['info']({
                message: 'Changed Successfully!',
                description: 'Default grade group changed Successfully!',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure?',
        content: 'Click Yes to delete this grade group!',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/grade/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: record.name + ' has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
